import { mainNavs } from "../../../Costants/costants";
import { useGeneralHooks } from "../../../Hooks/hooks";
import MainLogo from "../../Logos/mainLogo/mainLogo";
import { ButtonTypes } from "../../../Interfaces/componentTypes";
import Button from "../../Button/button";
import { useDrawerHooks } from "../../Drawer/drawer-hooks";
import CustomDrawer from "../../Drawer/CustomDrawer/customDrawer";
import Languages from "../../Languages/languages";
import MainDrawer from "../../Drawer/DrawerContents/MainDrawer/mainDrawer";
import { Menu } from "../../../Assets/Icons";
import styles from './mainHeader.module.scss';


const MainHeader: React.FC = () => {
  const { navigate, largeScreen, t } = useGeneralHooks();
  const { openDrawer, onCloseDrawer, onOpenDrawer } = useDrawerHooks();

  return (
    <>
      {
        largeScreen
          ?
          <div className={styles.header}>
            <MainLogo />
            <div className={styles.navContainer}>
              {/* <nav className={styles.navBox}>
                {
                  mainNavs.map((item, index) => {
                    return (
                      <div key={index} className={styles.navItem} onClick={() => navigate(item.href)}>
                        <p className={styles.navTitle}>{item.title}</p>
                      </div>
                    )
                  })
                }
              </nav> */}
            </div>
            <div className={styles.navBox2}>
              <nav className={styles.navButtons}>
                <Button
                  title={t('Login.Title')}
                  buttonType={ButtonTypes.Primery}
                  onClick={() => navigate('/login')}
                />
                <Languages/>
              </nav>
            </div>
          </div>
          :
          <div className={styles.mobileHeader}>
            <MainLogo />
            <nav className={styles.navButtons}>
            <Button
              title={t('Login.Title')}
              buttonType={ButtonTypes.Primery}
              onClick={() => navigate('/login')}
            />
            <Languages/>
            </nav>
            {/* <img src={Menu} alt="menuIcon" onClick={onOpenDrawer} />
            <CustomDrawer
              children={
                <MainDrawer
                />
              }
              open={openDrawer}
              onClose={onCloseDrawer}
            /> */}
          </div>
      }
    </>

  )
}

export default MainHeader
